export default __webpack_public_path__ + "static/media/codofil.f9501b9f.jpg";